import { ProductAction } from "../../../shared/interfaces/reducers/reducer.interface";
import * as types from "../consts";

const initState = {
  productList: [],
  productListIsOk: false
};

export default function CreateproductReducer(
  state = initState,
  action: ProductAction
) {
  switch (action.type) {
    case types.GET_PRODUCT_LIST_REQUEST:
      return { ...state, productListIsOk: false };
    case types.GET_PRODUCT_LIST_SUCCESS:
      return { ...state, productList: action.response, productListIsOk: true };
    case types.GET_PRODUCT_LIST_ERROR:
      return { ...state, productListIsOk: false };
    default:
      return state;
  }
}
